import { render, staticRenderFns } from "./TiiaAdd.vue?vue&type=template&id=3fcde24c&scoped=true&lang=pug&"
import script from "./TiiaAdd.vue?vue&type=script&lang=js&"
export * from "./TiiaAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcde24c",
  null
  
)

export default component.exports